import { useEffect, useState } from 'react';
import { auditLogApi, userApi } from '../../api';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ userId: '', entity: '', action: '', dateFrom: '', dateTo: '' });

  const load = async () => {
    const params = { module: 'materialwatch' };
    if (filter.userId) params.userId = filter.userId;
    if (filter.entity) params.entity = filter.entity;
    if (filter.action) params.action = filter.action;
    if (filter.dateFrom) params.dateFrom = filter.dateFrom;
    if (filter.dateTo) params.dateTo = filter.dateTo;
    const [l, u] = await Promise.all([auditLogApi.list(params), userApi.list()]);
    setLogs(l.data.data);
    setUsers(u.data.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, [filter]);

  const actionColor = { CREATE: 'text-green-700', UPDATE: 'text-blue-700', DELETE: 'text-red-700', APPROVE: 'text-green-700', REJECT: 'text-red-700', SEND: 'text-blue-700', RECEIVE: 'text-purple-700', COMPLETE: 'text-purple-700', CANCEL: 'text-gray-600', MODULE_ENTRY: 'text-indigo-700', BULK_UPLOAD: 'text-purple-700' };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="MaterialWatch activity history" />

      <div className="flex gap-3 mb-4 flex-wrap">
        <select className="input w-40" value={filter.userId} onChange={(e) => setFilter({ ...filter, userId: e.target.value })}>
          <option value="">All Users</option>
          {users.map((u) => <option key={u.id} value={u.id}>{u.username}</option>)}
        </select>
        <select className="input w-40" value={filter.entity} onChange={(e) => setFilter({ ...filter, entity: e.target.value })}>
          <option value="">All Entities</option>
          {['damage_report', 'group', 'inventory', 'module', 'permission_group', 'procurement', 'repair_ticket', 'requirement', 'safety_kit', 'site', 'stationery_inventory', 'stationery_item', 'transfer', 'worker', 'worker_kit', 'worker_request', 'worker_site_assignment'].map((e) => (
            <option key={e} value={e}>{e.replace(/_/g, ' ')}</option>
          ))}
        </select>
        <select className="input w-36" value={filter.action} onChange={(e) => setFilter({ ...filter, action: e.target.value })}>
          <option value="">All Actions</option>
          {['ADD_PHOTOS', 'APPROVE', 'ASSIGN', 'BULK_UPLOAD', 'CANCEL', 'CREATE', 'DELETE', 'GENERATE_SLIP', 'ISSUE', 'MARK_DAMAGED', 'MODULE_ENTRY', 'PERMANENT_DELETE', 'RECEIVE', 'REJECT', 'REPLY', 'RESTORE', 'RETURN', 'RETURN_FROM_MAINTENANCE', 'SCRAP', 'SEND', 'SEND_FOR_MAINTENANCE', 'SOFT_DELETE', 'TRANSFER', 'UPDATE', 'WITHDRAW'].map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <input className="input w-40" type="date" value={filter.dateFrom} onChange={(e) => setFilter({ ...filter, dateFrom: e.target.value })} />
        <input className="input w-40" type="date" value={filter.dateTo} onChange={(e) => setFilter({ ...filter, dateTo: e.target.value })} />
      </div>

      <div className="table-container">
        <table>
          <thead><tr><th>Time</th><th>User</th><th>Action</th><th>Entity</th><th>Name</th><th>IP</th></tr></thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td className="text-xs text-gray-500">{new Date(log.createdAt).toLocaleString()}</td>
                <td className="text-sm">{log.username || <span className="text-gray-400">system</span>}</td>
                <td><span className={`text-xs font-semibold uppercase ${actionColor[log.action] || 'text-gray-700'}`}>{log.action}</span></td>
                <td className="text-sm text-gray-600 capitalize">{log.entity?.replace(/_/g, ' ')}</td>
                <td className="text-sm">{log.entityName || '—'}</td>
                <td className="text-xs text-gray-400">{log.ipAddress || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
